import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const PhotoshootCard = ({ photoshoot }) => {
    const [imageLoaded, setImageLoaded] = useState(false);

    return (
        <div className="group overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 bg-white">
            <Link to={`/photography/${photoshoot.id}`} className="block">
                <div className="relative aspect-square bg-gray-200">
                    {!imageLoaded && (
                        <div className="absolute inset-0 flex items-center justify-center">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-sage-600"></div>
                        </div>
                    )}
                    <img
                        src={photoshoot.coverImage}
                        alt={photoshoot.title}
                        className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-300 ${imageLoaded ? 'opacity-100' : 'opacity-0'
                            }`}
                        onLoad={() => setImageLoaded(true)}
                    />

                    {/* Desktop hover overlay */}
                    <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-300 hidden md:block">
                        <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                            <h3 className="text-xl font-semibold mb-2">{photoshoot.title}</h3>
                            <p className="text-sm opacity-90 mb-2">{photoshoot.description}</p>
                            <p className="text-xs opacity-75">
                                {photoshoot.photoCount || 0} photos • {photoshoot.date}
                            </p>
                        </div>
                    </div>
                </div>
            </Link>

            {/* Mobile info section - always visible */}
            <div className="p-4 md:hidden">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{photoshoot.title}</h3>
                {photoshoot.description && (
                    <p className="text-sm text-gray-600 mb-3">{photoshoot.description}</p>
                )}
                <div className="flex justify-between items-center">
                    <p className="text-xs text-gray-500">
                        {photoshoot.photoCount || 0} photos • {photoshoot.date}
                    </p>
                    <Link
                        to={`/photography/${photoshoot.id}`}
                        className="bg-sage-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-sage-700 transition-colors"
                    >
                        View Gallery
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PhotoshootCard;